import { mapColor } from '@bubble-ui/particle-icon-colors';
import { useDesignContext } from '@klarna/designtokens';
import { defaultDesignTokens } from '../defaultDesignTokens';
export var iconDefaultStyleSheetGetter = _ref => {
  var {
    designVersion,
    color,
    colorToken,
    colorTokenArgs
  } = _ref;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  var designContext = useDesignContext(defaultDesignTokens);
  return {
    pathStyle: {
      fill: colorToken ? designContext.get(colorToken, colorTokenArgs).toRGBA() : mapColor(color,
      // TODO UI-3633 (introduce a new component token)
      color || designContext.get('icon/color').toRGBA(), designVersion),
      style: {
        transition: 'fill .2s ease'
      }
    }
  };
};
//# sourceMappingURL=icon.js.map